"use strict";

import _ from "lodash";

import AppConstants from "../constants/AppConstants.js";
import ModelFactory from "../models/ModelFactory.js";
import ObjectUtils from "../utils/ObjectUtils.js";

//Properties that always remain on the page block
var PAGE_BLOCK_PROP_PATHS = [
  ["id"],
  ["name"],
  ["slug"],
  ["wp"],
  ["z"],
  ["visible"],
  ["mobile", "locking"],
  ["desktop", "locking"],
  ["mobile", "hide"],
  ["desktop", "hide"],
  ["pubs", "scroll"],
];

var PAGE_BLOCK_CLICK_ACTIONS = [AppConstants.ELEMENT_ACTION_HIDE, AppConstants.ELEMENT_ACTION_SHOW];
var SITE_BLOCK_CLICK_ACTIONS = [
  AppConstants.ELEMENT_ACTION_HIDE_SITE_BLOCK,
  AppConstants.ELEMENT_ACTION_SHOW_SITE_BLOCK,
];

/**
 * This is used to convert an page block into a site block or convert an existing site block into a page block
 */
class BlockConverter {
  static toPageBlock(/** Object **/ block, /** Object **/ siteBlock) {
    var blockProps = ObjectUtils.pickDeep(block, PAGE_BLOCK_PROP_PATHS);

    var pageBlock = _.cloneDeep(siteBlock);

    _.unset(pageBlock, AppConstants.DESIGN_ITEM_PROP_PARENT_TYPE); //remove pType to default to page

    pageBlock = _.merge(pageBlock, blockProps);

    pageBlock = BlockConverter._processBlockElements(pageBlock, BlockConverter._toPageBlockElement);

    ObjectUtils.cleanProp(pageBlock, "pubs");

    return pageBlock;
  }

  static toSiteBlock(/** Object **/ block) {
    var blocks = {
      site: null,
      page: null,
    };

    var blockProps = ObjectUtils.pickDeep(block, PAGE_BLOCK_PROP_PATHS);

    var siteBlock = _.cloneDeep(block);
    _.set(siteBlock, AppConstants.DESIGN_ITEM_PROP_PARENT_TYPE, AppConstants.SITE_ITEM_SITE);
    _.set(siteBlock, AppConstants.DESIGN_ITEM_PROP_ID, ""); //clear the id it should be set when adding to container

    if (!_.has(siteBlock, "states")) {
      _.set(siteBlock, "states", []);
    }

    if (_.has(siteBlock, ["pubs", "scroll"])) {
      _.unset(siteBlock, ["pubs", "scroll"]);
    }

    siteBlock = BlockConverter._processBlockElements(siteBlock, BlockConverter._toSiteBlockElement);

    ObjectUtils.cleanProp(siteBlock, "pubs");

    //Start with a fresh block and merge in original properties
    var pageBlock = ModelFactory.getBlock();
    pageBlock = _.merge(pageBlock, blockProps);

    //set the parent block to missing.  Needs to set when block is set back into the container
    _.set(pageBlock, AppConstants.BLOCK_PROP_PARENT_BLOCK_ID, "missing");

    blocks.page = pageBlock;
    blocks.site = siteBlock;

    return blocks;
  }

  static _processBlockElements(/** Object **/ block, /** Function **/ elementProcessFunc) {
    block.elements = _.map(block.elements, elementProcessFunc);

    if (_.has(block, "states")) {
      _.forEach(block.states, function (state) {
        state.elements = _.map(state.elements, elementProcessFunc);
      });
    }

    return block;
  }

  static _toSiteBlockElement(element) {
    if (_.has(element, ["pubs", "click"])) {
      element = BlockConverter._filterPubType(element, "click", PAGE_BLOCK_CLICK_ACTIONS);
      element = ObjectUtils.cleanProp(element, "pubs");
    }

    return element;
  }

  static _toPageBlockElement(element) {
    if (_.has(element, ["pubs", "click"])) {
      element = BlockConverter._filterPubType(element, "click", SITE_BLOCK_CLICK_ACTIONS);
      element = ObjectUtils.cleanProp(element, "pubs");
    }

    return element;
  }

  static _filterPubType(item, pubType, types) {
    var pubs = _.get(item, ["pubs", pubType], []);

    _.remove(pubs, function (action) {
      return _.indexOf(types, action.type) >= 0;
    });

    if (_.isEmpty(pubs)) {
      _.unset(item, ["pubs", pubType]);
    } else {
      _.set(item, ["pubs", pubType], pubs);
    }

    return item;
  }
}

export default BlockConverter;
export { PAGE_BLOCK_PROP_PATHS, PAGE_BLOCK_CLICK_ACTIONS, SITE_BLOCK_CLICK_ACTIONS };
